module.exports = __webpack_public_path__ + "img/home_topBG1.7b142a7b.jpg";